import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ViewChild, ViewContainerRef, ComponentRef, ComponentFactoryResolver, Inject, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { first, takeUntil, takeWhile } from 'rxjs/operators';
import { LgvTSHelper } from '../../core/utility/ts-helper';

@Component({
    selector: 'lus-modal-form',
    templateUrl: './modal-form.component.html',
    styleUrls: ['./modal-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalFormComponent implements OnInit, OnDestroy {

    @ViewChild('target', { read: ViewContainerRef, static: true })
    vcRef: ViewContainerRef;
    componentRef: ComponentRef<any>;
    error: any;
    isComponentAlive: boolean;
    IsLoading: boolean = false;
    IsLoading$ = new BehaviorSubject(this.IsLoading);

    onDestroy$ = new Subject();

    constructor(
        private dialogRef: MatDialogRef<ModalFormComponent>,
        private resolver: ComponentFactoryResolver,
        private changeDetectorRefs: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data) {

    }

    ngOnInit() {
        const factory = this.resolver.resolveComponentFactory(this.data.component);
        this.componentRef = this.vcRef.createComponent(factory);
        this.componentRef.instance.data = this.data.content;

        //*************************************
        this.componentRef.instance.InputData = this.data.componentData;

        if (this.componentRef.instance.OnOutputStatusChanged) {
            this.componentRef.instance.OnOutputStatusChanged
                .pipe(takeUntil(this.onDestroy$)).subscribe(x => {
                    if (x === 'Success') {
                        this.dialogRef.close({ event: 'confirm' });
                    }
                    if (x === 'Cancel') {
                        this.dialogRef.close({ event: 'confirm' });
                    }
                });
        }
    }

    ngOnDestroy() {
        this.componentRef.destroy();
        this.isComponentAlive = false;

        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    navigateOption() {
        this.dialogRef.close();
        // this.router.navigateByUrl('/login');
    }

    clickTrigger(action?: string) {
        console.log('*** action: ' + action);
        if (action === 'SUBMIT' || action === 'CONFIRM') {
            this.isComponentAlive = true;
            /**_form is the generic variable name of FormGroup in the form component**/
            if (!this.componentRef.instance._form.invalid) {
                this.IsLoading$.next(true);
                /**Make sure form component has a onSubmit() method**/
                let res = this.componentRef.instance.onSubmit();
                res.pipe(takeWhile(i => this.isComponentAlive)).subscribe(result => {
                    if (result) {
                        if (result.hasOwnProperty('error')) {
                            this.error = result.error.errors;
                        } else {
                            setTimeout(() => {
                                this.dialogRef.close({ event: 'confirm' });
                            }, 400)

                        }
                        this.IsLoading$.next(false);
                    }

                    this.changeDetectorRefs.detectChanges();
                });

            }

        }

    }

    save() {
        this.dialogRef.close();
    }

    close() {
        this.dialogRef.close({ event: 'close' });
    }

    isDataContentVisible(content: any) {
        return content && LgvTSHelper.isString(content);
    }
}
